import Enum from './enum'

class CompareMode extends Enum
{
  constructor(value) {
    super(value);
  }
}

CompareMode.init({
  NONE: 'None',
  NORMAL: 'normal',
  AVERAGE: 'average'
}, {
  NONE: 'compare-mode.none',
  NORMAL: 'compare-mode.normal',
  AVERAGE: 'compare-mode.average'
});

export default CompareMode;
